export default __webpack_public_path__ + "static/media/metis.7b156d24.svg";